import { useEcxToast } from '@edgeconnex/design-system'
import type { Tenant } from '@/apiServices/types'
import { ActiveTenantService } from '@/services/ActiveTenantService'

// Feeds the authoritative active-tenant list to the header tenant picker. Every holder of a fresh
// tenant list calls this — the layout at mount, and the admin Tenants page after each change — so a
// tenant that was just deactivated, renamed or deleted leaves the picker and stops being the active
// scope straight away, instead of lingering (and silently emptying every scoped grid) until the
// next page reload.
export function useTenantPickerSync() {
  const toast = useEcxToast()

  function syncTenantPicker(tenants: Tenant[]): void {
    const dropped = ActiveTenantService.setViewAsOptions(
      tenants.filter((tenant) => tenant.isActive).map((tenant) => tenant.tenantName),
    )
    if (dropped) {
      toast.add({
        severity: 'warn',
        summary: `Tenant "${dropped}" is no longer available — switched to All.`,
        life: 6000,
      })
    }
  }

  return { syncTenantPicker }
}
